import _ from 'lodash'

export function toCamelCaseDeep (object) {
  return convertCaseDeep(object, _.camelCase)
}

export function camelToUnderscore (key) {
  let result = key.replace(/([A-Z])/g, ' $1')
  return result.split(' ').join('_').toLowerCase()
}

export function toSnakeCaseDeep (object) {
  return convertCaseDeep(object, _.snakeCase)
}

export function camelCaseFromHypencase (str) {
  return str.replace(/\b-([a-z])/g, (_, char) => char.toUpperCase())
}

function convertCaseDeep (object, transformPropertyName) {
  if (_.isString(object) || _.isNumber(object)) {
    return object
  }
  if (_.isArray(object)) {
    return _.map(object, obj => convertCaseDeep(obj, transformPropertyName))
  }

  let convertedObject = _.cloneDeep(object)

  // Convert keys to camel case
  convertedObject = _.mapKeys(
    convertedObject,
    (value, key) => transformPropertyName(key)
  )

  // Recursively apply throughout object
  return _.mapValues(
    convertedObject,
    value => {
      if (_.isPlainObject(value)) {
        return convertCaseDeep(value, transformPropertyName)
      } else if (_.isArray(value)) {
        return _.map(value, obj => convertCaseDeep(obj, transformPropertyName))
      }
      return value
    }
  )
}
